import { Card, CardBody, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import CreditsTransactionsTable from "./components/table/CreditTransactionsTable";
import MonthlyUsageTable from "./components/table/MonthlyUsageTable";

const LedgerPage = () => {
    return (
        <Card className="shadow-sm py-4">
            <CardHeader>
                <CardTitle>Ledger</CardTitle>
                <CardDescription>
                    Review your credit transactions and historical monthly usage
                </CardDescription>
            </CardHeader>
            <CardBody>
                {/* Credits Section */}
                <h4 className="fw-bolder text-dark mb-4 mt-5">Credits</h4>
                <CreditsTransactionsTable />

                {/* Separator */}
                <div className="separator separator-dashed my-10"></div>

                {/* Monthly Usage Section */}
                <h4 className="fw-bolder text-dark mb-4 mt-5">Monthly Usage</h4>
                <MonthlyUsageTable />
            </CardBody>

        </Card>
    );
};

export default LedgerPage;